import { makeStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) => ({
    logotype: {
        color: theme.palette.type === 'dark' ? theme.palette.primary.main : 'white',
        marginLeft: theme.spacing(2.5),
        marginRight: theme.spacing(2.5),
        fontWeight: 500,
        fontSize: 18,
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    appBar: {
        width: '100%',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toolbar: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        minHeight: '80px',
    },
    hide: {
        display: 'none',
    },
    grow: {
        flexGrow: 1,
    },
    search: {
        position: 'relative',
        borderRadius: 25,
        paddingLeft: theme.spacing(2.5),
        width: 36,
        backgroundColor: alpha(theme.palette.common.black, 0),
        transition: theme.transitions.create(['background-color', 'width']),
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: alpha(theme.palette.common.black, 0.08),
        },
    },
    searchFocused: {
        backgroundColor: alpha(theme.palette.common.black, 0.08),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 250,
        },
    },
    searchIcon: {
        width: 36,
        right: 0,
        height: '100%',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create('right'),
        '&:hover': {
            cursor: 'pointer',
        },
    },
    searchIconOpened: {
        right: theme.spacing(1.25),
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        height: 36,
        padding: 0,
        paddingRight: 36 + theme.spacing(1.25),
        width: '100%',
    },
    messageContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    headerMenu: {
        marginTop: theme.spacing(7),
    },
    headerMenuList: {
        display: 'flex',
        flexDirection: 'column',
    },
    headerMenuItem: {
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
    },
    headerMenuButton: {
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0.5),
    },
    headerMenuButtonCollapse: {
        marginRight: theme.spacing(2),
    },
    headerIcon: {
        fontSize: 28,
        color: 'rgba(255, 255, 255, 0.35)',
    },
    headerIconCollapse: {
        color: theme.palette.type === 'dark' ? theme.palette.primary.main : 'white',
    },
    profileMenu: {
        minWidth: 265,
    },
    profileMenuUser: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    profileMenuItem: {
        color: theme.palette.text.hint,
    },
    profileMenuIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.text.hint,
    },
    profileMenuLink: {
        fontSize: 16,
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    messageNotification: {
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.background.light,
        },
    },
    messageNotificationSide: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginRight: theme.spacing(2),
    },
    messageNotificationBodySide: {
        alignItems: 'flex-start',
        marginRight: 0,
    },
    sendMessageButton: {
        margin: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textTransform: 'none',
    },
    sendButtonIcon: {
        marginLeft: theme.spacing(2),
    },
    headerRightLabel: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
    },
    headerButton: {
        color: theme.palette.primary,
        backgroundColor: theme.palette.background.light,
        marginRight: theme.spacing(3),
    },
    smileAcademyLogo: {
        width: '12rem',
        marginLeft: theme.spacing(3),
    },
}));
